import { render, staticRenderFns } from "./ListarFormacaoPorStatusDialog.vue?vue&type=template&id=5ac60d28&scoped=true"
import script from "./ListarFormacaoPorStatusDialog.vue?vue&type=script&lang=js"
export * from "./ListarFormacaoPorStatusDialog.vue?vue&type=script&lang=js"
import style0 from "./ListarFormacaoPorStatusDialog.vue?vue&type=style&index=0&id=5ac60d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac60d28",
  null
  
)

export default component.exports